import { render, staticRenderFns } from "./ModalTypes.vue?vue&type=template&id=6a30c306&"
import script from "./ModalTypes.vue?vue&type=script&lang=js&"
export * from "./ModalTypes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports